import React, { FC } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableCell,
} from "@mui/material";
import { ISelection } from "../helper";

interface Props {
  selection?: ISelection;
  onChange: (key: string, value: string | number) => void;
}

export const EditableCellValues: FC<Props> = ({ selection, onChange }) => {
  const handleChange = async (e: any, field: string, isString?: boolean) => {
    const { value } = e.target;
    onChange(field, isString ? value : Number(value));
  };

  return (
    <>
      <TableCell align="right">
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Status</InputLabel>
          <Select
            value={selection?.status || "pending approval"}
            label="Status"
            size="small"
            name={Math.random().toString()}
            sx={{ minWidth: 120 }}
            onChange={(e) => handleChange(e, "status", true)}
          >
            <MenuItem value="pending approval">Pending Approval</MenuItem>
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="completed">Completed</MenuItem>
          </Select>
        </FormControl>
      </TableCell>
      <TableCell align="right">
        <input
          style={{
            width: "50px",
            background: "lightgrey",
          }}
          data-field="impressions"
          value={selection?.impressions || 0}
          onChange={(e) => handleChange(e, "impressions")}
        />
      </TableCell>
      <TableCell align="right">
        <input
          style={{
            width: "50px",
            background: "lightgrey",
          }}
          data-field="plays"
          value={selection?.plays || 0}
          onChange={(e) => handleChange(e, "plays")}
        />
      </TableCell>
      <TableCell align="right">
        <>
          <input
            style={{
              width: "50px",
              marginRight: "10px",
              background: "lightgrey",
            }}
            data-field="watch_time"
            value={selection?.watch_time || 0}
            onChange={(e) => handleChange(e, "watch_time")}
          />
          {((selection?.watch_time || 0) / 60).toFixed(1)} minutes
        </>
      </TableCell>
      <TableCell align="right">
        <input
          style={{
            width: "50px",
            background: "lightgrey",
          }}
          data-field="likes"
          value={selection?.likes || 0}
          onChange={(e) => handleChange(e, "likes")}
        />
      </TableCell>
      <TableCell align="right">
        <input
          style={{
            width: "100px",
            background: "lightgrey",
          }}
          data-field="placement_url"
          value={selection?.placement_url}
          onChange={(e) => handleChange(e, "placement_url", true)}
        />
      </TableCell>
    </>
  );
};
